import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import config from '../../config';
import Button from '../ui-kit/Button/Button';
import Modal from '../ui-kit/Modal/Modal';

type OfferInfoModalProps = {
  isOffersModalOpen: boolean;
  setOffersModalOpen: (isOffersModalOpen: boolean) => void;
  hideBackdrop?: boolean;
};

export const OfferInfoModal = ({ isOffersModalOpen, setOffersModalOpen, hideBackdrop }: OfferInfoModalProps) => {
  const { t } = useTranslation();

  const maxDiffPercentage = config.offer.maxDiffPercentage;

  const learnMoreModalContent = t('pages.offer.learn-more-modal.content', { returnObjects: true, percentage: maxDiffPercentage }) as {
    title: string;
    content: string[];
  }[];

  return (
    <Modal
      open={isOffersModalOpen}
      onClose={() => setOffersModalOpen(false)}
      className="offers-info-modal"
      hideBackdrop={hideBackdrop}
      title={t('pages.offer.learn-more-modal.title')}
      actions={
        <Button buttonType="primary" size="medium" onClick={() => setOffersModalOpen(false)} fullWidth>
          {t('pages.offer.learn-more-modal.ok')}
        </Button>
      }
      maxContentHeight={360}
      contentPaddingInline={24}
    >
      {learnMoreModalContent?.map(({ title, content }) => (
        <Fragment key={title}>
          <div className="learn-more-title">{title}</div>
          <ul>
            {content.map((subContent) => (
              <li key={subContent}>{subContent}</li>
            ))}
          </ul>
        </Fragment>
      ))}
    </Modal>
  );
};
